<template>
  <div class="mb-6">
    <div v-for="(monthlyBookedCapacity, index) in value"
      :key="monthlyBookedCapacity.index">
      <v-row>
        <v-col
          class="pb-0 px-1 text-center font-weight-bold"
          cols="1"
          v-for="bookedCapacity in monthlyBookedCapacity.values"
          :key="bookedCapacity.month"
        >
          {{ bookedCapacity.month + '-' + monthlyBookedCapacity.year }}
        </v-col>
      </v-row>

      <v-divider color="black" class="my-1"></v-divider>

      <v-row>
        <v-col
          class="pb-0 px-1 font-weight-bold"
          cols="1"
          v-for="bookedCapacity in currentValues(index, monthlyBookedCapacity.values)"
          :key="bookedCapacity.month"
        >
          <input
            class="reserved-capacity-input text-center"
            type="text"
            disabled
            v-model="bookedCapacity.valueCurrent"
            :placeholder="bookedCapacity.valueCurrent ? '' : '-'"
            style="background-color: #c6d8f0"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          class="pb-0 px-1 font-weight-bold"
          cols="1"
          v-for="bookedCapacity in monthlyBookedCapacity.values"
          :key="bookedCapacity.month"
        >
          <template v-if="edit === true && bookedCapacity.wasEditable === true">
            <VTextFieldWithValidation
              hide-details
              :rules="{
                numeric: true
              }"
              customClass="text-center reserved-capacity-text-field"
              dense
              v-model="bookedCapacity.value"
              v-mask="'#######'"
              outlined
              label=""
              style="background-color: #fff"
            />
          </template>

          <template v-else>
            <input
              class="reserved-capacity-input text-center"
              type="text"
              disabled
              v-model="bookedCapacity.value"
              :placeholder="bookedCapacity.value ? '' : '-'"
              :style="bookedCapacity.wasEditable === true ?
                'background-color: #fff' : 'background-color: #d8d8d8'"
            />
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonthlyReservedCapacity',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    currentMonthlyCapacities: {
      type: Object,
      default: null,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    currentValues(index, monthlyBookedCapacities) {
      if (this.currentMonthlyCapacities == null) {
        return monthlyBookedCapacities;
      }
      return this.currentMonthlyCapacities.monthlyBookedCapacities[index].values;
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.reserved-capacity-input {
  width: 100%;
  color: rgba(0, 0, 0, 0.75);
  border-radius: 1px;
  height: 40px;
}

.reserved-capacity-input::placeholder {
  color: rgba(0, 0, 0, 0.75);
}

.reserved-capacity-input::-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.75);
}

.reserved-capacity-input--new {
  border: 1px solid #bfcfe2;
}

.reserved-capacity-text-field.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control > .v-input__slot,
.reserved-capacity-text-field.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding: 0 2px;
}
</style>
